<template>
  <div>
    <div class="btn-wrapper">
      <div class="ml-2">
        <create-dependencia-req
          :dependencias="dependencias"
          v-if="isDev"
          @refetchDepReqs="this.fetchDeps"
        />
        <!-- <create-dependencia v-if="isDev" /> -->
      </div>
      <v-btn
        @click="deleteSelected"
        color="red"
        variant="plain"
        size="x-small"
        v-if="isDev"
        :append-icon="!this.isLoading ? 'mdi-delete-outline' : ''"
        >Excluir Selecionado
        <v-progress-circular
          v-if="this.isLoading"
          class="ml-2"
          indeterminate
          size="20"
      /></v-btn>
    </div>

    <div ref="network" id="network"></div>
  </div>
</template>

<script>
import axios from 'axios';
import { Network, DataInterfaceNodes } from 'vis-network';
import vis from 'vis-network/dist/vis-network.min.js';

import CreateDependenciaReq from '@/components/dialogs/CreateDependenciaReq.vue';
import store from '@/store/store';

// import CreateDependencia from './dialogs/CreateDependencia.vue';

export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    id: Number,
    // eslint-disable-next-line vue/require-default-prop
    isCsu: { type: Boolean, default: true },
  },
  data() {
    return {
      dependencias: [],
      data: null,
      nodes: null,
      edges: null,
      container: null,
      isLoading: false,
      network: { type: DataInterfaceNodes },
      options: {},
      selectedNodeId: null,
    };
  },
  mounted() {
    this.fetchDeps();
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    async fetchDeps() {
      const apiUrl = process.env.VUE_APP_API_URL || 'http://localhost:3000';
      axios
        .get(apiUrl + '/api/v1/requisitos/dependencia/' + this.id, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((res) => {
          // console.log(res.data);
          this.dependencias = [...res.data];
          this.drawGraph();
        });
    },
    async deleteSelected() {
      // console.log('Clicked!!');
      if (this.selectedNodeId !== null) {
        // console.log(this.selectedNodeId, this.id);
        if (this.selectedNodeId != this.id) {
          const req = this.nodes.get(this.selectedNodeId).from;
          const efe = this.nodes.get(this.selectedNodeId).to;
          console.log(req, efe);
          const apiUrl = process.env.VUE_APP_API_URL || 'http://localhost:3000';
          this.isLoading = true;
          console.log(req, efe);
          try {
            const result = await axios.post(
              apiUrl + '/api/v1/requisitos/deleteDep',
              {
                // eslint-disable-next-line camelcase
                id_requisito: parseInt(req),
                // eslint-disable-next-line camelcase
                id_dependencia_eferente: parseInt(efe),
              },
              {
                headers: {
                  Authorization: `Bearer ${store.state.token}`,
                },
              },
            );
            this.isLoading = false;
            this.nodes.remove(this.selectedNodeId);
            this.selectedNodeId = null;
            console.log(result);
          } catch (error) {
            console.log(error);
            this.isLoading = false;
          }
        }
      }
    },
    handleKeyDown(event) {
      if (event.key === 'Backspace') {
        this.deleteSelected();
      }
    },
    drawGraph() {
      this.nodes = [];
      this.edges = [];
      // console.log(this.dependencias, 'deps');
      // console.log(this.dependencias);
      // eslint-disable-next-line no-unused-vars
      this.dependencias.forEach((item) => {
        this.nodes = [
          ...this.nodes,
          {
            id: item.id_requisito,
            label: item.req_ident,
            physics: false,
            from: item.id_requisito,
            to: item.id_dependencia_eferente,
          },
          {
            id: item.id_dependencia_eferente,
            label: item.ef_ident,
            physics: false,
            from: item.id_requisito,
            to: item.id_dependencia_eferente,
          },
        ];

        this.edges = [
          ...this.edges,
          {
            from: item.id_requisito,
            to: item.id_dependencia_eferente,
            // label: item.tipo_dependencia.toLowerCase(),
            arrows: 'to',
          },
        ];
      });
      console.log(this.nodes, 'nodes');

      // this.dependencias.forEach((item, index) => {
      //   if (index === 0) {
      //     if (this.id === item.id_requisito) {
      //       this.nodes = [
      //         ...this.nodes,
      //         {
      //           id: item.id_requisito,
      //           label: item.req_ident,
      //           fixed: {
      //             y: true,
      //             x: true,
      //           },
      //           from: item.id_requisito,
      //           to: item.id_dependencia_eferente,
      //         },
      //       ];
      //     } else {
      //       this.nodes = [
      //         ...this.nodes,
      //         {
      //           id: item.id_dependencia_eferente,
      //           label: item.ef_ident,
      //           fixed: {
      //             y: true,
      //             x: true,
      //           },
      //           from: item.id_requisito,
      //           to: item.id_dependencia_eferente,
      //         },
      //       ];
      //     }
      //   }

      //   // console.log(index);
      //   if (this.id === item.id_requisito) {
      //     this.nodes = [
      //       ...this.nodes,
      //       {
      //         id: item.id_dependencia_eferente,
      //         label: item.ef_ident,
      //         physics: false,
      //         from: item.id_requisito,
      //         to: item.id_dependencia_eferente,
      //       },
      //     ];
      //     // console.log('1o', this.nodes);
      //   } else {
      //     this.nodes = [
      //       ...this.nodes,
      //       {
      //         id: item.id_requisito,
      //         label: item.req_ident,
      //         physics: false,
      //         from: item.id_requisito,
      //         to: item.id_dependencia_eferente,
      //       },
      //     ];
      //     // console.log('2o', this.nodes);
      //   }

      //   this.edges = [
      //     ...this.edges,
      //     {
      //       from: item.id_requisito,
      //       to: item.id_dependencia_eferente,
      //       // label: item.tipo_dependencia.toLowerCase(),
      //       arrows: 'to',
      //     },
      //   ];
      // });

      // Melhorar estrategia
      let size = this.nodes.filter(
        (item) => item.id === this.$route.params.id,
      ).length;
      const isRepeated = size > 1;
      // console.log(isRepeated);
      while (size > 1) {
        if (isRepeated) {
          const index = this.nodes
            .map((item) => item.id)
            .indexOf(this.$route.params.id);
          if (index > -1) {
            this.nodes.splice(index, 1);
          }
        }
        size--;
      }
      this.nodes = this.nodes.filter((item) => {
        if (item.id.toString() !== this.$route.params.id.toString()) {
          if (item.to === this.$route.params.id.toString()) {
            return false;
          }
        }

        return true;
      });
      this.nodes = new vis.DataSet(this.nodes);
      this.edges = new vis.DataSet(this.edges);
      this.container = document.getElementById('network');
      this.data = {
        nodes: this.nodes,
        edges: this.edges,
      };
      this.options = {};
      // eslint-disable-next-line no-unused-vars
      const network = new Network(this.container, this.data, this.options);
      network.on('selectNode', (event) => {
        this.selectedNodeId = event.nodes[0];
      });
    },
  },
  computed: {
    isDev() {
      return localStorage.getItem('formaAtuacao') === '"DESENVOLVEDOR"';
    },
  },
  components: { CreateDependenciaReq },
};
</script>

<style scoped>
#network {
  width: calc(100% - 2rem);
  height: 400px;
  margin: 1rem;
  border-radius: 5px;
  border: 1px solid lightgray;
}
.btn-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
